'use client';

import React, { useState, useEffect } from 'react';
import { Image } from '../../wag-react/core-components/image';
import { Flex } from '../Flex';
import { StyledSystemProps } from '../../types';
export type ImagePreviewFile = File;
export type Props = StyledSystemProps & {
  value: ImagePreviewFile;
  containerProps?: StyledSystemProps;
};
const getFileBase64 = async (file: File) => {
  const base64 = (await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event => resolve(event.target.result as string);
    reader.onerror = reject;
  })) as string;
  return base64;
};
export const ImagePreview = ({
  value,
  containerProps,
  ...rest
}: Props) => {
  const [filePreview, setFilePreview] = useState(null);
  useEffect(() => {
    const getPreview = async () => {
      if (!value) {
        return;
      }
      const preview = await getFileBase64(value);
      setFilePreview(preview);
    };
    getPreview();
  }, [value]);
  return <Flex flexDirection="column" height="100%" {...containerProps} data-sentry-element="Flex" data-sentry-component="ImagePreview" data-sentry-source-file="index.tsx">
      <Image src={filePreview} style={{
      // TODO - Add support on `wag-react`
      objectFit: 'cover'
    }} alt="image-preview" {...rest} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </Flex>;
};